<template>
  <div class="card-box">
    <h4 class="header-title m-t-0 m-b-10">{{ source.name }}</h4>
    <el-table :data="getServices(source.id)" style="width: 100%">
      <el-table-column type="expand">
        <template slot-scope="scope">
          <div class="row">
            <div v-for="meta in scope.row.meta" class="col-md-6">
              <strong>{{ meta.name }}</strong> :
              <span v-if="isDateValid(meta.value)">{{ meta.value | moment('DD/MM/YYYY') }}</span>
              <span v-else-if="meta.value === null">-</span>
              <span v-else-if="typeof(meta.value) === 'object'">{{ meta.value.join(', ') }}</span>
              <span v-else>{{ meta.value }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="name" sortable label="Nom" width="220"></el-table-column>
      <el-table-column prop="source" sortable label="Plat." width="100">
        <template slot-scope="scope">
          <source-app :name="scope.row.source" size="tiny"></source-app>
        </template>
      </el-table-column>
      <el-table-column prop="start_at" sortable label="Début">
        <template slot-scope="scope">
          <span v-if="scope.row.start_at">{{ scope.row.start_at.date | moment('DD/MM/YYYY') }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="end_at" sortable label="Fin">
        <template slot-scope="scope">
          <span v-if="scope.row.end_at">{{ scope.row.end_at.date | moment('DD/MM/YYYY') }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="Status" width="220">
        <template slot-scope="scope">
          <div v-if="getServiceStatus(scope.row).text != ''" :class="'text-' + getServiceStatus(scope.row).color">
            {{ getServiceStatus(scope.row).text }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import SourceApp from '@db2b/keystone/components/Entities/SourceApp.vue'
  import moment from 'moment'

  export default {
    components: {SourceApp},
    name: 'customer-services',
    props: ['customer', 'source'],
    methods: {
      getServices (source) {
        return this.customer.services.filter(service => service.source === source)
      },
      getServiceStatus (service) {
        return this.$model.service.getStatus(service)
      },
      isDateValid (date) {
        return moment(date, 'YYYY-MM-DD hh:mm:ss', true).isValid() || moment(date, 'YYYY-MM-DD', true).isValid()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CustomerServices.vue?ad66e178